/**
 * Figma 6163:41948 — 리뷰쓰기(작성 중) 데모용.
 * `/review/write?demo=filled` 로 확인.
 */

/** 첫 문단만 사용해 80자 이내, 본문 영역과 톤 유지 */
export const REVIEW_WRITE_DEMO_BODY =
  '합주실이 넓고 쾌적했어요. 특히 드럼 세트가 상태가 좋고, 방음도 잘 돼서 마음껏 연습할 수 있었습니다. 예약도 간편하고, 가격도 괜찮아요.';

export const REVIEW_WRITE_DEMO_IMAGE_URLS = [
  'https://www.figma.com/api/mcp/asset/73c43fa9-7ca9-42e2-a84a-b501219309bd',
  'https://www.figma.com/api/mcp/asset/599c9e3f-bba5-4e18-ad50-47934a656d63',
] as const;
